import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProjectChecklistAsyncPipe } from '@portal-core/project-checklists/pipes/project-checklist-async/project-checklist-async.pipe';

@NgModule({
  declarations: [ProjectChecklistAsyncPipe],
  imports: [CommonModule],
  exports: [ProjectChecklistAsyncPipe],
  providers: [ProjectChecklistAsyncPipe]
})
export class ProjectChecklistAsyncModule { }
